import React from 'react';
import { CheckIcon } from 'lucide-react';
const points = ['Instant digital download', 'No special kit required', 'Easy → Guided → Challenge'];
export function TrustBar() {
  return <section className="w-full bg-blueprint px-5 py-8" data-id="element-213" data-mp="y992bftwmv2p">
      <ul className="mx-auto flex max-w-3xl flex-col items-center justify-center gap-3 text-center sm:flex-row sm:gap-8" data-id="element-214" data-mp="y6mlepl4j37t">
        {points.map(point => <li key={point} className="flex items-center gap-2" data-id="element-215" data-mp="1qyg02cljbgmw">
            <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-teal/15 text-teal" data-id="element-216" data-mp="1uyzuh8eq465c">
              <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-217" data-mp="1gzqikkxjvy76" />
            </span>
            <span className="text-sm font-semibold text-navy" data-id="element-218" data-mp="1ly1qgq4abymr">{point}</span>
          </li>)}
      </ul>
    </section>;
}